import Vue from "vue";
import VueRouter from "vue-router";
import adminRouter from "./module_admin/router.js";
import userRouter from "./module_user/router.js";
import b2bUserRouter from "./module_b2b_users/router.js"
import sportsClient from "./module_clients/router"
import fitClient from "./clients/module_fit_summit/router"
import campaignRouter from "./module_campaign/router/"
import testRouter from "./module_testing/router"
import physioAssessmentRouter from "./module_assessment/router.js"
import fsbAssessmentRouter from "./module_fsb_assessment/router.js"
import managementDashboard from "./module_dashboard/router";
import homepageDashboard from "./module_homepage/router";
// import ForgotPassword from ;
// import ResetPassword from './views/ResetPassword.vue';
import store from "@/store";
import defaultRoutes from "./utils/defaultRoutes.js";
import Bowser from "bowser";

Vue.use(VueRouter);

const routes = [
    // As /:tenant route is in b2bUserRouter, Hence having lowest route priority
    ...homepageDashboard,
    ...fitClient,
    ...campaignRouter,
    ...sportsClient,
    ...adminRouter,
    ...userRouter,
    ...physioAssessmentRouter,
    ...fsbAssessmentRouter,
    ...testRouter,
    ...managementDashboard,
    ...b2bUserRouter,
    {
        path: "/unsupported-browser",
        name: "NotSupportedBrowserPage",
        component: () => import("./views/NotSupportedBrowserPage.vue")
    },
    {
        path: '*',
        name: 'Not Found',
        component: () => import('./views/FallBack404.vue')
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    linkActiveClass: "active",
    scrollBehavior (to, from, savedPosition) {
        // set the scroll of the main container to top, to fix inconsistent scroll issue
        if(document.getElementById("content-wrapper") != null){
            document.getElementById("content-wrapper").scrollTop = 0;
        }
        if(document.getElementById("outer-container") != null){
            document.getElementById("outer-container").scrollTop = 0;
        }

        // $(".ef-container>.content").scrollIntoView();
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
});

export default router;

export function noAuth(to, from, next) {
    if (localStorage.getItem('token') == null) {
        next();
    } else {
        next({ name: "workout" });
    }
}

const DEFAULT_TITLE = 'EliteFit.AI';
router.afterEach((to, from) => {
    Vue.nextTick(() => {
        document.title = to.meta.title || DEFAULT_TITLE;
    });
});

function isNotSupportedBrowser() {
    const userAgent = window.navigator.userAgent;
    // allow if webview
    if (userAgent.includes("EliteFitWebView") || userAgent.includes("AppleWebKit")) return false;

    if (userAgent.includes("TelegramWebApp") || 
    userAgent.includes("TelegramBot") || 
    userAgent.toLowerCase().includes("telegram") ||
    (window.Telegram && window.Telegram.WebApp)) {
        console.log("Telegram WebApp detected");
    return false;
}

    const browser = Bowser.getParser(userAgent);

    // Browser names: https://github.com/bowser-js/bowser/blob/HEAD/src/constants.js
    const isValidBrowser = browser.satisfies({
        chrome: ">=1",  // Allow all versions of Chrome
        safari: ">=1",  // Allow all versions of Safari
        edge: ">=1",    // Allow all versions of Edge
    });
    return !isValidBrowser
}
router.beforeEach(async (to, from, next) => {
    if (to.name !== 'SessionIDSignIn' && to.query.sessionID) {
        try {
            // clone query and remove sessionID
            const { sessionID, ...restQuery } = to.query;
            // logout current user
            await store.dispatch('userPortalLoginWithSessionID', {sessionID})

            // redirect to same route without sessionID
            return next({
                path: to.path,
                query: restQuery,
                hash: to.hash,
                params: to.params,
                replace: true, // avoid adding an extra entry in browser history
            });
        } catch (error) {
            console.error("Session verification failed:", error);
            return next("/");
        }
    }

    if (to.name === "NotSupportedBrowserPage") {
        return next();
    } else if (isNotSupportedBrowser()) {
        return next({ name: "NotSupportedBrowserPage"});
    }

    // redirect to login page if not logged in and trying to access a restricted page
    const { authorize } = to.meta;
    const currentUser = store.state.userInfo;
    if (authorize) {
        if (!currentUser) {
            return next({ path: '/ef/sign-in' });
        }

        // check if route is restricted by role
        if (authorize.length && !authorize.includes(currentUser.role)) {
            const defaultPath = defaultRoutes[currentUser.role] ? defaultRoutes[currentUser.role] : '/';
            // role not authorised so redirect to home page
            return next({ path: defaultPath });
        }
    }

    next();
})
